import { Box, Inline, Stack } from 'braid-design-system';
import type { FC } from 'react';

import { Display } from 'src/libs/Display';

import * as styles from './JobApplicationCardLayout.css';

interface JobApplicationCardLayoutProps {
  avatarCheckBox: JSX.Element;
  fullNameAndCertifiedIcon: JSX.Element;
  recentRoleAndTenure: JSX.Element;
  keyInfo: JSX.Element | null;
  badges: JSX.Element;
  roleRequirementsDisclosure: JSX.Element | null;
  highFitDisclosure: JSX.Element | null;
  matchedSkillsDisclosure: JSX.Element | null;
  appliedDate: JSX.Element;
  attachmentsAndRecords: JSX.Element | null;
  actionButtons: JSX.Element;
  highlightTag: JSX.Element | null;
}

export const JobApplicationCardLayout: FC<JobApplicationCardLayoutProps> = ({
  avatarCheckBox,
  fullNameAndCertifiedIcon,
  recentRoleAndTenure,
  keyInfo,
  badges,
  roleRequirementsDisclosure,
  highFitDisclosure,
  matchedSkillsDisclosure,
  appliedDate,
  attachmentsAndRecords,
  actionButtons,
  highlightTag,
}) => (
  <Box
    background="surface"
    paddingX="small"
    paddingY="medium"
    position="relative"
    data={{ testid: 'job-application-card' }}
    className={styles.applicationCard}
  >
    <Stack space="medium">
      <Box display="flex" justifyContent="spaceBetween" alignItems="center">
        <Inline space="xsmall">
          <Display tablet desktop>
            {avatarCheckBox}
          </Display>
          <Stack space={['small', 'xsmall']}>
            {fullNameAndCertifiedIcon}
            {recentRoleAndTenure}
          </Stack>
        </Inline>
        {highlightTag}
      </Box>
      <Box paddingLeft={[null, 'small']}>
        <Stack space="medium">
          <Stack space="small">
            {keyInfo}
            {badges}
          </Stack>
          {roleRequirementsDisclosure}
          {highFitDisclosure}
          {matchedSkillsDisclosure}
          {appliedDate}
        </Stack>
      </Box>
      <Box
        display="flex"
        justifyContent="spaceBetween"
        gap="medium"
        flexWrap="wrap"
        alignItems="center"
        paddingLeft={[null, 'small']}
      >
        {attachmentsAndRecords}
        <Box className={styles.right}>{actionButtons}</Box>
      </Box>
    </Stack>
  </Box>
);
